import { render, staticRenderFns } from "./gradeTemplate.vue?vue&type=template&id=61b34977&"
import script from "./gradeTemplate.vue?vue&type=script&lang=js&"
export * from "./gradeTemplate.vue?vue&type=script&lang=js&"
import style0 from "./gradeTemplate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports